/* @flow */
import * as React from "react";
import LocalSettings from "nexia_mobile/models/local_settings";
import BackboneListener from "nexia_mobile/components/BackboneListener";

type Props = {
  children: ({
    maybeInvert: Object,
    isDarkMode: boolean,
  }) => React.Node,
};

export default class DarkModeInverter extends React.Component<Props> {
  render() {
    return (
      <BackboneListener listenTo={LocalSettings} events={["settings_changed"]}>
        {() => {
          const isDarkMode = LocalSettings.getDarkMode();

          return this.props.children({
            isDarkMode,
            maybeInvert: {
              filter: isDarkMode ? "invert(100%) hue-rotate(180deg)" : "",
            },
          });
        }}
      </BackboneListener>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DarkModeInverter.jsx